exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".WsOQX {\n  padding-left: 15px;\n  padding-right: 15px;\n}", ""]);

// exports
exports.locals = {
	"root": "WsOQX"
};